import { render, staticRenderFns } from "./TaskAllPersons.vue?vue&type=template&id=f8464660"
import script from "./TaskAllPersons.vue?vue&type=script&lang=js"
export * from "./TaskAllPersons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports